var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { contactTypeTranslations } from "./contactTypeTranslations";
var PREFIX = "ui-br-publishers.validation.summary";
var ADDRESS_FIELDS = {
    street: "street",
    postalCode: "postalCode",
    municipality: "municipality",
    region: "region",
    "region.id": "region",
    addressCode: "addressCode",
};
var addressLabels = function (section) {
    return Object.fromEntries(Object.entries(ADDRESS_FIELDS).map(function (_a) {
        var path = _a[0], field = _a[1];
        return [
            "".concat(section, ".").concat(path),
            { section: section, field: field },
        ];
    }));
};
/**
 * Field labels by the form path pattern, array indices replaced by `*`. A contact value is
 * labelled by the contact type at runtime (see {@link contactValueLabel}).
 */
var FIELD_LABELS = __assign(__assign(__assign({ name: { section: "general", field: "name" }, legalForm: { section: "general", field: "legalForm" }, status: { section: "general", field: "status" }, companyNumber: { section: "general", field: "companyNumber" }, taxNumber: { section: "general", field: "taxNumber" }, birthDate: { section: "general", field: "birthDate" }, nameSuffix: { section: "general", field: "nameSuffix" }, qualifier: { section: "general", field: "qualifier" }, "registrations.*.registrationAgency": {
        section: "registrations",
        field: "registrationAgency",
    }, "registrations.*.registrationIntent": {
        section: "registrations",
        field: "registrationIntent",
    } }, addressLabels("mainAddress")), addressLabels("mailingAddress")), { "contacts.*.type": { section: "contacts", field: "contactType" }, "contacts.*.value": { section: "contacts", field: "contactValue" }, "contacts.*.info": { section: "contacts", field: "contactInfo" }, "alternativeNames.*.name": {
        section: "alternativeNames",
        field: "alternativeName",
    }, "alternativeNames.*.nameSuffix": {
        section: "alternativeNames",
        field: "nameSuffix",
    }, "alternativeNames.*.qualifier": {
        section: "alternativeNames",
        field: "qualifier",
    }, "alternativeNames.*.type": {
        section: "alternativeNames",
        field: "alternativeNameType",
    }, "guarantors.*.firstName": { section: "guarantors", field: "firstName" }, "guarantors.*.lastName": { section: "guarantors", field: "lastName" }, "guarantors.*.email": { section: "guarantors", field: "email" }, "guarantors.*.roles": { section: "guarantors", field: "roles" }, "guarantors.*.titlesBefore": {
        section: "guarantors",
        field: "titlesBefore",
    }, "guarantors.*.titlesAfter": { section: "guarantors", field: "titlesAfter" }, "guarantors.*.contacts": {
        section: "guarantors",
        field: "guarantorContact",
    }, "guarantors.*.contacts.*.type": {
        section: "guarantors",
        field: "guarantorContact",
    }, "guarantors.*.contacts.*.value": {
        section: "guarantors",
        field: "guarantorContact",
    }, "guarantors.*.contacts.*.info": {
        section: "guarantors",
        field: "guarantorContact",
    }, workSpecification: { section: "workSpecification" }, "workSpecification.title": {
        section: "workSpecification",
        field: "title",
    }, "workSpecification.subtitle": {
        section: "workSpecification",
        field: "subtitle",
    }, "workSpecification.volumeNumber": {
        section: "workSpecification",
        field: "volumeNumber",
    }, "workSpecification.partTitle": {
        section: "workSpecification",
        field: "partTitle",
    }, "workSpecification.authors.*.firstName": {
        section: "workSpecification",
        field: "authorFirstName",
    }, "workSpecification.authors.*.lastName": {
        section: "workSpecification",
        field: "authorLastName",
    }, "workSpecification.publicationDate": {
        section: "workSpecification",
        field: "publicationDate",
    }, "workSpecification.editionNumber": {
        section: "workSpecification",
        field: "editionNumber",
    }, "workSpecification.coEditionWith": {
        section: "workSpecification",
        field: "coEditionWith",
    }, "workSpecification.publicationForm": {
        section: "workSpecification",
        field: "publicationForm",
    }, "workSpecification.publicationType.printedPublications": {
        section: "workSpecification",
        field: "printedPublications",
    }, "workSpecification.eBookFormats": {
        section: "workSpecification",
        field: "eBookFormats",
    }, "workSpecification.otherFormats.*.format": {
        section: "workSpecification",
        field: "otherFormat",
    }, "workSpecification.dataCarrierVersions": {
        section: "workSpecification",
        field: "dataCarrierVersions",
    }, "workSpecification.audioBookFormats": {
        section: "workSpecification",
        field: "audioBookFormats",
    } });
/** zod's built-in English texts for a missing value. */
var RAW_REQUIRED = /^(Required|Expected .+, received (undefined|null))$/;
/** zod's other built-in English texts. */
var RAW_INVALID = /^(Expected |Invalid |Unrecognized |String must |Number must |Array must |Too (small|big))/;
var isRecord = function (value) {
    return value !== null && typeof value === "object";
};
var valueAt = function (values, segments) {
    return segments.reduce(function (current, segment) { return (isRecord(current) ? current[segment] : undefined); }, values);
};
var czechMessage = function (message, formatMessage) {
    var _a;
    var trimmed = (_a = message === null || message === void 0 ? void 0 : message.trim()) !== null && _a !== void 0 ? _a : "";
    if (!trimmed || RAW_REQUIRED.test(trimmed)) {
        return formatMessage({ id: "ui-br-publishers.validation.zod.required" });
    }
    if (RAW_INVALID.test(trimmed)) {
        return formatMessage({
            id: "ui-br-publishers.validation.zod.invalidValue",
        });
    }
    return trimmed;
};
/** The label of a publisher contact value: the contact type (e.g. "Web") when known. */
var contactValueLabel = function (segments, values, formatMessage) {
    var type = valueAt(values, __spreadArray(__spreadArray([], segments.slice(0, -1), true), ["type"], false));
    var translation = typeof type === "string" ? contactTypeTranslations[type] : undefined;
    return translation ? formatMessage(translation) : undefined;
};
var describeField = function (path, values, formatMessage) {
    var _a;
    var segments = path.split(".");
    var pattern = segments.map(function (s) { return (/^\d+$/.test(s) ? "*" : s); }).join(".");
    var label = FIELD_LABELS[pattern];
    if (!label) {
        var name_1 = (_a = __spreadArray([], segments, true).reverse().find(function (s) { return !/^\d+$/.test(s); })) !== null && _a !== void 0 ? _a : path;
        return formatMessage({ id: "".concat(PREFIX, ".field.unknown") }, { name: name_1 });
    }
    var section = formatMessage({ id: "".concat(PREFIX, ".section.").concat(label.section) });
    if (!label.field)
        return section;
    var field = (pattern === "contacts.*.value" &&
        contactValueLabel(segments, values, formatMessage)) ||
        formatMessage({ id: "".concat(PREFIX, ".field.").concat(label.field) });
    // the item of the section's list, numbered from the second one
    var index = segments.find(function (s) { return /^\d+$/.test(s); });
    var itemNumber = index !== undefined ? Number(index) + 1 : 1;
    var numberedField = itemNumber > 1
        ? formatMessage({ id: "".concat(PREFIX, ".item") }, { field: field, number: itemNumber })
        : field;
    return "".concat(section, " \u2013 ").concat(numberedField);
};
/**
 * Describes every invalid field of a form for the "Formulář nelze odeslat…" summary in Czech:
 * "<section> – <field>: <message>". zod's raw English texts ("Required", "Invalid input", …) are
 * never shown — they are replaced by a generic Czech message (Tools 75665).
 *
 * @param invalidFields the invalid fields collected from the react-hook-form error tree
 * @param formatMessage the react-intl message formatter
 * @param values the current form values, used to name a contact by its type
 * @return one human-readable line per invalid field
 */
export var describeInvalidFields = function (invalidFields, formatMessage, values) {
    return invalidFields.map(function (_a) {
        var path = _a.path, message = _a.message;
        return "".concat(describeField(path, values, formatMessage), ": ").concat(czechMessage(message, formatMessage));
    });
};
